import { router } from '@inertiajs/vue3';
import { Capacitor } from '@capacitor/core';
import { isBundledMobileApp } from '@/mobile/native/apiBase';
import { isMobileOfflinePath } from '@/mobile/offline/mobileOfflineRoutes';
import { isOnline } from '@/services/SyncService';

function visitPathname(url: string | URL): string {
  if (typeof url === 'string') {
    return new URL(url, window.location.origin).pathname;
  }

  return url.pathname;
}

function showOfflineMessage(message: string): void {
  window.alert(message);
}

export function registerOfflineNavigationGuard(): void {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  router.on('before', (event) => {
    if (isOnline.value) {
      return;
    }

    const visit = event.detail.visit;
    const pathname = visitPathname(visit.url);
    const method = (visit.method ?? 'get').toLowerCase();

    if (method !== 'get') {
      event.preventDefault();
      showOfflineMessage(
        'Sem internet. Rascunhos e alterações ficam guardados localmente e sincronizam quando a rede voltar.',
      );
      return;
    }

    if (isBundledMobileApp()) {
      return;
    }

    if (!isMobileOfflinePath(pathname)) {
      event.preventDefault();
      showOfflineMessage(
        'Sem internet: só funcionam rotas do app mobile (Início, Relatórios, Obras, Agenda, Perfil e RDO) já abertas ou sincronizadas com rede. Áreas administrativas e outras rotas precisam de internet.',
      );
    }
  });

  router.on('exception', () => {
    if (!isOnline.value) {
      showOfflineMessage(
        'Esta página ainda não está no cache offline. Com rede, abra-a uma vez após o sync ou aguarde o pré-carregamento automático.',
      );
    }
  });

  router.on('success', () => {
    if (isBundledMobileApp()) {
      return;
    }

    void import('@/mobile/offline/prefetchFieldPages').then(({ prefetchCurrentMobilePage }) =>
      prefetchCurrentMobilePage(),
    );
  });
}
